
<!--document details-->
<div>
    <app-booking-documents [context]="'allotmentContext'"
        [currentBooking]="this.salesService.currentBooking"></app-booking-documents>
</div>